<template>
  <div class="capacity-org-page">
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="开通运力模块请前往「商家运营 → 商家主体」。本页负责审核历史申请、机构状态与清算；不再在此单独建 B 端账号。"
    />

    <div class="mb-12px flex flex-wrap items-center gap-8px">
      <el-radio-group v-model="listFilter" size="small" @change="onFilterChange">
        <el-radio-button value="">全部</el-radio-button>
        <el-radio-button value="pending">待审/待开通</el-radio-button>
        <el-radio-button value="active">运营中</el-radio-button>
        <el-radio-button value="rejected">已驳回</el-radio-button>
        <el-radio-button value="suspended">停用</el-radio-button>
        <el-radio-button value="liquidating">清算中</el-radio-button>
        <el-radio-button value="closed">已归档</el-radio-button>
      </el-radio-group>
      <!-- 开通入口已迁至「商家运营 → 商家主体」，本页不再提供按钮
      <el-button v-hasPermi="['merchant:entity:create']" type="primary" @click="goOpenCapacity">
        开通运力模块
      </el-button>
      -->
      <el-button link type="primary" @click="loadOrgs">刷新</el-button>
    </div>

    <el-table
      :data="orgs"
      size="small"
      border
      highlight-current-row
      class="w-full"
      style="width: 100%"
      @current-change="onSelectOrg"
    >
      <el-table-column prop="orgId" label="机构 ID" min-width="140" />
      <el-table-column prop="name" label="名称" min-width="140" />
      <el-table-column prop="city" label="城市" min-width="80" />
      <el-table-column label="来源" min-width="100">
        <template #default="{ row }">
          {{ row.source === 'apply' ? '商家申请' : '内部开站' }}
        </template>
      </el-table-column>
      <el-table-column prop="contactPhone" label="联系人" min-width="120" />
      <el-table-column label="状态" min-width="100">
        <template #default="{ row }">
          <el-tag :type="statusTagType(row.status)" size="small">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template #default="{ row }">
          <template v-if="row.status === 'pending'">
            <template v-if="row.source === 'apply'">
              <el-button link type="success" @click="onApprove(row)">同意开通</el-button>
              <el-button link type="danger" @click="onReject(row)">驳回</el-button>
            </template>
            <el-button v-else link type="success" @click="onActivate(row)">开通</el-button>
          </template>
          <el-button
            v-if="['active', 'suspended', 'liquidating'].includes(row.status)"
            link
            type="warning"
            @click="openLiquidation(row)"
          >
            清算
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="total"
      v-model:page="pageNo"
      v-model:limit="pageSize"
      @pagination="loadOrgs"
    />

    <p v-if="selectedOrg" class="mt-8px text-13px text-[var(--el-text-color-secondary)]">
      当前选中：{{ selectedOrg.orgId }} · {{ statusLabel(selectedOrg.status) }}
      <template v-if="selectedOrg.rejectReason"> · 驳回：{{ selectedOrg.rejectReason }}</template>
    </p>

    <!-- 清算抽屉 -->
    <el-drawer
      v-model="liqVisible"
      title="退出清算向导（D43）"
      size="480px"
      destroy-on-close
    >
      <el-alert
        class="mb-12px"
        type="warning"
        :closable="false"
        title="顺序：active → suspended → liquidating → closed（禁跳步）。本页不展示/不发邀请码。"
      />
      <p v-if="selectedOrg" class="mb-12px text-13px">
        {{ selectedOrg.orgId }} · {{ selectedOrg.name }} ·
        <el-tag :type="statusTagType(selectedOrg.status)" size="small">
          {{ statusLabel(selectedOrg.status) }}
        </el-tag>
      </p>
      <el-steps :active="stepIndex" align-center finish-status="success" class="mb-16px">
        <el-step title="active" description="运营中" />
        <el-step title="suspended" description="停用" />
        <el-step title="liquidating" description="清算中" />
        <el-step title="closed" description="已归档" />
      </el-steps>
      <el-form>
        <el-button :disabled="!canSuspend" @click="onAdvance('suspended')">① 停用</el-button>
        <el-button :disabled="!canLiquidate" type="warning" @click="onAdvance('liquidating')">
          ② 进入清算
        </el-button>
        <el-button :disabled="!canContinue" @click="onContinue">继续处置</el-button>
        <el-button :disabled="!selectedOrgId" link type="primary" @click="loadChecklist">
          刷新清单
        </el-button>
      </el-form>
      <el-descriptions v-if="checklist" class="mt-12px" :column="1" border size="small">
        <el-descriptions-item label="无进行中单">
          <span :class="checkClass(checklist.noActiveOrders)">{{ yesNo(checklist.noActiveOrders) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="分润已结">
          <span :class="checkClass(checklist.billsSettled)">{{ yesNo(checklist.billsSettled) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="邀请码作废">
          <span :class="checkClass(checklist.inviteVoided)">{{ yesNo(checklist.inviteVoided) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="骑手已脱离">
          <span :class="checkClass(checklist.ridersDetached)">{{ yesNo(checklist.ridersDetached) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="保证金已记">
          <span :class="checkClass(checklist.depositRecorded)">{{ yesNo(checklist.depositRecorded) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="可 closed">
          <span :class="checkClass(checklist.canClose)">{{ yesNo(checklist.canClose) }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-form class="mt-12px" label-width="72px">
        <el-form-item label="保证金">
          <el-select v-model="depositOutcome" class="!w-full">
            <el-option label="退还 refund" value="refund" />
            <el-option label="扣罚 deduct" value="deduct" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="depositNote" placeholder="归档备注" clearable />
        </el-form-item>
        <el-button type="danger" :disabled="!canClose" @click="onClose">③ 归档 closed</el-button>
      </el-form>
    </el-drawer>
  </ContentWrap>
  </div>
</template>

<script lang="ts" setup>
import * as OrgApi from '@/api/capacity/org'
// import { merchantEntityLink } from '@/api/merchant/merchant-entity'
import { ContentWrap } from '@/components/ContentWrap'
import { ElMessage, ElMessageBox } from 'element-plus'

defineOptions({ name: 'CapacityOrgPlatform' })

// const router = useRouter()

const STATUS_LABEL: Record<string, string> = {
  pending: '待审/待开通',
  active: '运营中',
  rejected: '已驳回',
  suspended: '已停用',
  liquidating: '清算中',
  closed: '已归档'
}

const listFilter = ref('')
const pageNo = ref(1)
const pageSize = ref(10)
const total = ref(0)
const liqVisible = ref(false)
const orgs = ref<OrgApi.OrgItem[]>([])
const selectedOrgId = ref('')
const checklist = ref<OrgApi.LiquidationChecklist>()
const depositOutcome = ref('refund')
const depositNote = ref('')

const selectedOrg = computed(() => orgs.value.find((o) => o.orgId === selectedOrgId.value))

const canSuspend = computed(() => selectedOrg.value?.status === 'active')
const canLiquidate = computed(() => selectedOrg.value?.status === 'suspended')
const canContinue = computed(() => selectedOrg.value?.status === 'liquidating')
const canClose = computed(
  () => selectedOrg.value?.status === 'liquidating' && !!checklist.value?.canClose
)

const stepIndex = computed(() => {
  const s = selectedOrg.value?.status || checklist.value?.status
  if (s === 'closed') return 4
  if (s === 'liquidating') return 3
  if (s === 'suspended') return 2
  if (s === 'active') return 1
  return 0
})

const yesNo = (v: boolean) => (v ? '是' : '否')
const checkClass = (ok: boolean) =>
  ok ? 'text-[var(--el-color-success)]' : 'text-[var(--el-color-danger)]'
const statusLabel = (s: string) => STATUS_LABEL[s] || s
const statusTagType = (s: string) => {
  if (s === 'active') return 'success'
  if (s === 'pending') return 'info'
  if (s === 'rejected') return 'danger'
  if (s === 'suspended' || s === 'liquidating') return 'warning'
  if (s === 'closed') return 'info'
  return ''
}

const loadOrgs = async () => {
  const r = await OrgApi.orgList({
    status: listFilter.value || undefined,
    pageNo: pageNo.value,
    pageSize: pageSize.value,
  })
  orgs.value = r?.list || []
  total.value = r?.total || 0
  if (selectedOrgId.value && !orgs.value.some((o) => o.orgId === selectedOrgId.value)) {
    selectedOrgId.value = ''
    checklist.value = undefined
  }
}

const onFilterChange = () => {
  pageNo.value = 1
  loadOrgs()
}

const onSelectOrg = (row: OrgApi.OrgItem | undefined) => {
  selectedOrgId.value = row?.orgId || ''
  checklist.value = undefined
}

const openLiquidation = (row: OrgApi.OrgItem) => {
  selectedOrgId.value = row.orgId
  liqVisible.value = true
  loadChecklist()
}

// const goOpenCapacity = () => {
//   router.push(merchantEntityLink({ action: 'create', module: 'CAPACITY' }))
// }

const onActivate = async (row: OrgApi.OrgItem) => {
  await ElMessageBox.confirm(`确认开通机构 ${row.orgId}？将进入 active 并发邀请码。`, '开通确认', {
    type: 'warning'
  })
  const r = await OrgApi.orgActivate(row.orgId)
  if (!r.success) {
    ElMessage.error(r.message || '开通失败')
    return
  }
  ElMessage.success('已开通')
  await loadOrgs()
}

const onApprove = async (row: OrgApi.OrgItem) => {
  await ElMessageBox.confirm(
    `同意「${row.name}」入驻平台？将开通并发邀请码。`,
    '同意申请',
    { type: 'warning' }
  )
  const r = await OrgApi.orgApprove(row.orgId)
  if (!r.success) {
    ElMessage.error(r.message || '同意失败')
    return
  }
  ElMessage.success('已同意开通')
  await loadOrgs()
}

const onReject = async (row: OrgApi.OrgItem) => {
  const { value } = await ElMessageBox.prompt('请填写驳回原因', '驳回申请', {
    inputPattern: /\S+/,
    inputErrorMessage: '原因不能为空',
    type: 'warning'
  })
  const r = await OrgApi.orgReject({ orgId: row.orgId, reason: value })
  if (!r.success) {
    ElMessage.error(r.message || '驳回失败')
    return
  }
  ElMessage.success('已驳回')
  await loadOrgs()
}

const loadChecklist = async () => {
  if (!selectedOrgId.value) return
  checklist.value = await OrgApi.orgChecklist(selectedOrgId.value)
}

const onAdvance = async (target: string) => {
  const r = await OrgApi.orgAdvance(selectedOrgId.value, target)
  if (!r.success) {
    ElMessage.error(r.message || '推进失败')
    return
  }
  ElMessage.success('已推进至 ' + statusLabel(target))
  await Promise.all([loadOrgs(), loadChecklist()])
}

const onContinue = async () => {
  const r = await OrgApi.orgContinueLiquidation(selectedOrgId.value)
  if (!r.success) {
    ElMessage.error(r.message || '继续处置失败')
    return
  }
  ElMessage.success('已继续处置')
  await Promise.all([loadOrgs(), loadChecklist()])
}

const onClose = async () => {
  if (!depositNote.value.trim()) {
    ElMessage.warning('请填写保证金归档备注')
    return
  }
  const r = await OrgApi.orgClose(selectedOrgId.value, depositOutcome.value, depositNote.value.trim())
  if (!r.success) {
    ElMessage.error(r.message || '归档失败')
    await loadChecklist()
    return
  }
  ElMessage.success('机构已归档 closed')
  await Promise.all([loadOrgs(), loadChecklist()])
}

onMounted(loadOrgs)
</script>

<style scoped>
.capacity-org-page {
  width: 100%;
  box-sizing: border-box;
}
.capacity-org-page :deep(.el-card) {
  width: 100%;
}
</style>
